import React from 'react';
import Component from '../../components/Component';
import Datagrid from '../../components/Datagrid';
import ImageGrid from '../../components/ImageGrid';
import Renderers from '../../helpers/Renderers';
import DbInfo from '../../dbinfo';
import c from '../../constants';
import {FormManager} from 'reactis-forms';
import {FilterInput, Select, SearchInput} from 'reactis-inputs';
import {FilterResetButton, FilterField} from 'reactis-datagrid';
import {Button, ButtonToolbar} from 'react-bootstrap';
import {AlertWindow} from 'reactis-modal';
import EventEmitter from '../../EventEmitter';
import DateRange from '../../components/Form/DateRange';
import {connect} from 'react-redux';
import ActiveSelect from '../../components/Form/ActiveSelect';
import {bindActionCreators} from 'redux';
import AddButton from '../../components/AddButton';
import store from 'store2';

export default class List extends Component {

	static contextTypes = {
		location: React.PropTypes.object
	};

	constructor(props, context) {
		super(props);

			const filterSchema = {
			fulltext: { class: SearchInput },
			edit: {
				class: FilterResetButton,
				visible: () => this.filter.isChanged(),
				onClick: () => this.filter.reset()
			}
		};
		this.filter = new FormManager(filterSchema);
		this.defaultSort =  this.props.defaultState ? this.props.defaultState.sort : {column: 'id', 'direction': 'desc'};

		// default
		let filter = {};
		// session

		// url
		this.filterUrl = context.location.query && context.location.query.filter;
		if (this.filterUrl) {
			filter = JSON.parse(context.location.query.filter);
		}
		this.defaultFilter = filter;
	}

	componentDidMount() {
		this.changeListener = () => {
			this.refs.datagrid.getWrappedInstance().refresh();
		};
		EventEmitter.on('image.change', this.changeListener);
	}

	componentWillUnmount() {
		EventEmitter.removeListener('image.change', this.changeListener);
	}

	handleOpen(row) {
		if (this.props.onSelect) {
			this.props.onSelect(row);
		}
		else {
			this.props.actions.openTabForm('image', row.id, row);
		}
	}

	handleNewClick(e) {
		e.preventDefault();
		this.props.newTab();
	}

	render() {

		const buttons =
			<AddButton link="/email" onClick={(e) => this.handleNewClick(e)}>
				Nový obrázek
			</AddButton>;

		const popup = this.props.popup;
		const style = {};
		if (popup) {
			style.padding = 0;
			style.marginTop = -25;
			style.backgroundColor = '#fff';
		}

		return (
			<div style={style}>
				<Datagrid
					ref="datagrid"
					id="image"
					api="image.getList"
					limit={24}
					buttons={!popup ? buttons : false}
					filters={['fulltext']}
					filter={this.filter}
					saveState={true}
					getRowClassName={null}
					bodyComponentClass={ImageGrid}
					bodyComponentProps={{popup: popup, editClick: (row) => this.handleOpen(row)}}
					columnModel={this.columnModel}
					defaultFilter={this.defaultFilter}
					forceFilter={this.filterUrl}
					defaultSort={this.defaultSort}
				/>
			</div>
		);
	}
}


// WEBPACK FOOTER //
// ./src/containers/Image/List.js